import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface SystemStatusState {
  maintenanceMode: boolean;
  offline: boolean;
}

const initialState: SystemStatusState = {
  maintenanceMode: false,
  offline: false,
};

export const SystemStatusSlice = createSlice({
  name: 'systemStatus',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.maintenanceMode = action.payload;
    },
    setOfflineStatus: (state, action: PayloadAction<boolean>) => {
      state.offline = action.payload;
    },
  },
});

export const { setMaintenanceMode, setOfflineStatus } = SystemStatusSlice.actions;
export default SystemStatusSlice.reducer;
